<template>
	<v-alert prominent flat dismissible :value="visible" :v-if="visible" v-model="visible" :type="type" class="alert" style="border-radius: 0">
		<div class="title">{{ this.value }}</div>
		<div class="detail">
			<slot />
		</div>
	</v-alert>
</template>

<script>
export default {
	name: 'Alert',
	props: {
		type: { type: String, default: 'error' },
		value: { type: String },
	},
	data() {
		return {
			visible: false,
		}
	},
	watch: {
		value(v) {
			this.visible = !!v
		},
		visible(v) {
			if (!v) return this.close()
			setTimeout(this.close, 5000)
		},
	},
	methods: {
		close() {
			this.visible = false
			this.$emit('input', null)
		},
	},
	mounted() {
		this.visible = !!this.value
	},
}
</script>

<style scoped>
.title { font-size: 14pt; font-weight: bold; }
</style>